import { useReviewProfiles } from './useReviewProfiles';
import { useLocalStorage } from 'javascripts/hooks';
import { useEffect } from 'react';

export const useStoredSelectedFeedbackReviewProfileId = () => {
  const { reviewProfiles, defaultReviewProfile, isReviewProfilesLoading } =
    useReviewProfiles();

  const [
    storedSelectedFeebackReviewProfileId,
    setStoredSelectedFeedbackReviewProfileId,
  ] = useLocalStorage(
    `selectedFeedbackReviewProfileId`,
    defaultReviewProfile?.id,
  );

  useEffect(() => {
    if (isReviewProfilesLoading) {
      return;
    }
    if (
      reviewProfiles.length > 0 &&
      !reviewProfiles.some(
        (profile) => profile.id === storedSelectedFeebackReviewProfileId,
      )
    ) {
      setStoredSelectedFeedbackReviewProfileId(reviewProfiles[0].id);
    }
  }, [
    isReviewProfilesLoading,
    storedSelectedFeebackReviewProfileId,
    setStoredSelectedFeedbackReviewProfileId,
    reviewProfiles,
  ]);

  return {
    isLoading: isReviewProfilesLoading,
    storedSelectedFeebackReviewProfileId,
    setStoredSelectedFeedbackReviewProfileId,
  };
};
